import { Form, FormInstance, Radio, Row } from "antd";
import { useMemo } from "react";
import { OnDateOption } from "./OnDateOption";
import { AfterOption } from "./AfterOption";
import { ScheduleEmailOptions } from "../..";

type SettingsProps = {
  form: FormInstance;
  options?: ScheduleEmailOptions;
};

export const Settings = ({
  form,
  options = { enabledOnEndDate: true, enabledOnOccurrences: true, enabledUntilAccountClosed: true }
}: SettingsProps) => {
  const recurrentOptions = useMemo(() => {
    const optionsList: any[] = [];

    if (options.enabledUntilAccountClosed) {
      optionsList.push({
        value: 3,
        label: "When account is closed"
      });
    }
    if (options.enabledOnEndDate) {
      optionsList.push({
        value: 2,
        label: <OnDateOption form={form} />
      });
    }
    if (options.enabledOnOccurrences) {
      optionsList.push({
        value: 1,
        label: <AfterOption form={form} />
      });
    }

    return optionsList;
  }, [form, options]);

  return (
    <Row className="d-block ml-6 mt-4">
      <span className="text-md title">Repeat Ends</span>
      <Form.Item label="" name="endConditionType" className="mb-0">
        <Radio.Group className="mt-3 recurrent-options" options={recurrentOptions} />
      </Form.Item>
    </Row>
  );
};
